import { extractIdFromAccount } from '@/lib/utils';
import { useAccount, useMsal } from '@azure/msal-react';

export const useUser = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0]);
  let guid = '';
  if (account) {
    guid = extractIdFromAccount(account);
  }

  return { guid };
};
